<template>
  <div class="TradingHall">
    <!--头部banner-->
    <div class="banner">
      <h3 class="w">交易信息 <span class="title">Transaction information</span></h3>
      <div class="bannertable w">
        <el-table :header-cell-style="{background:'#DAE1F0',color:'#798AAC'}" ref="table" max-height="390"
                  :data="table_trade" :row-class-name="tableRowClassName" style="width: 100%">
          <el-table-column prop="goodsName" label="成交商品名称">
          </el-table-column>
          <el-table-column label="成交价格" width="180">
            <template v-slot:="{row,$index}">
              <span :style="{color: row.goodsTotalAmount > 0 ? '#BD4444' : textcolor[row.goodsPriceType]}">{{
                  row.goodsTotalAmount == 0 ? row.goodsPriceType : row.goodsTotalAmount
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tradeTime" label="成交时间">
          </el-table-column>
          <el-table-column prop="goodsCategory" label="商品类型">
          </el-table-column>
          <el-table-column prop="name" label="供应商">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--主体-->
    <div class="main w">
      <div class="TwoTableBox">
        <div class="leftTable">
          <h3 class="w">商品供需信息 <span class="title">Supply and demand information</span>
            <span class="xulb"
                  v-if="this.$store.state.user.userInfo.supplierStatus==1"
                  @click="clickxulb">查看更多</span>
          </h3>
          <div class="supply">
            <div class="xqxx">需求信息</div>
            <div class="xqxxbox">
              <el-table :header-cell-style="{background:'#DAE1F0',color:'#798AAC'}" max-height="350"
                        :data="table_commodity_demand" :row-class-name="tableRowClassName" style="width: 100%">
                <el-table-column prop="enterpriseName" label="公司名称" width="150">
                </el-table-column>
                <el-table-column prop="demandTitle" label="需求名称">
                </el-table-column>
                <el-table-column prop="demandDescribe" label="需求描述">
                </el-table-column>
                <el-table-column prop="checkTime" label="发布时间">
                </el-table-column>
                <el-table-column prop="minBudget" label="最低报价">
                  <template v-slot:="{row,$index}">
                    <span style="color:#0CA82E">{{ row.minBudget }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="maxBudget" label="最高报价">
                  <template v-slot:="{row,$index}">
                    <span style="color:#BD4444">{{ row.maxBudget }}</span>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </div>
          <div class="demand">
            <div class="gyxx">供应信息</div>
            <div class="gyxxbox">
              <el-table :header-cell-style="{background:'#DAE1F0',color:'#798AAC'}" max-height="350"
                        :data="table_supply"
                        :row-class-name="tableRowClassName" style="width: 100%">
                <el-table-column prop="supplierName" label="供应商简称" width="150">
                </el-table-column>
                <el-table-column prop="goodsName" label="最新发布数据/产品">
                </el-table-column>
                <el-table-column label="商品价格">goodsTotalAmount
                  <template v-slot:="{row,$index}">
                    <span :style="{color: textcolorother[row.goodsPriceType]}">{{
                        row.goodsPrice == 0 ? goodsPriceType[row.goodsPriceType] : row.goodsPrice
                      }}</span>
                  </template>
                  <!--                  <template v-slot:="{row,$index}">-->
                  <!--                    {{ row.goodsPrice == 0 ? goodsPriceType[row.goodsPriceType] : row.goodsPrice }}-->
                  <!--                  </template>-->
                </el-table-column>
                <el-table-column prop="readNum" label="浏览量">
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot:="{row,$index}">
                    <el-button @click="handleClick(row,$index)" type="text" size="small"
                               style="font-size: 16px;font-family: MicrosoftYaHeiUISemibold;color: #2569F2;font-weight: 600">
                      查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>


<!--      <div class="echartsBox1">-->
<!--        <div class="left">-->
<!--          &lt;!&ndash;柱状图&ndash;&gt;-->
<!--          <div class="barBox">-->
<!--            <div class="barButton">-->
<!--              <div @click="clickBarButton('month')" :class="{currentClass: currentbutton === 'month'}">按月</div>-->
<!--              <div @click="clickBarButton('week')" :class="{currentClass: currentbutton === 'week'}">按周</div>-->
<!--            </div>-->
<!--            <div class="bar" ref="bar"></div>-->
<!--          </div>-->

<!--          &lt;!&ndash;饼状图&ndash;&gt;-->
<!--          <div class="pieBox">-->
<!--            <div class="pie1" ref="ecPie1"></div>-->
<!--            <div class="pie2" ref="ecPie2"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="right">-->
<!--          <div class="dataShow_rankTitle">排行榜</div>-->
<!--          <rankList :todayCount="todayCount" :allCount="allCount"></rankList>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import rankList from "@/components/RemoteSensingMall/rankList.vue";

export default {
  name: 'TradingHall',
  components: {
    rankList
  },
  data() {
    return {
      textcolor: {
        "面议": '#D2A223',
        "免费": '#0CA82E',
        "商品金额": '#BD4444',
      },
      textcolorother: {
        "1": '#BD4444',
        "2": '#D2A223',
        "3": '#0CA82E',
      },

      hotImg: require("@/assets/imgs/TradingHall/hot.svg"),

      currentbutton: 'month',

      table_trade: [], //交易信息
      table_commodity_demand: [], //商品需求信息
      table_supply: [], //商品供应信息
      goodsPriceType: {
        1: '0',
        2: '面议',
        3: '免费'
      },

      //柱状图
      barecharts: null,
      //按月显示的数据
      monthData: {
        date: [],
        count: []
      },
      //按周显示的数据
      weekData: {
        date: [],
        count: []
      },

      //饼状图
      pie1echarts: null,
      pie2echarts: null,
      pie1_option: [],
      pie2_option: [],

      todayCount: 0,
      allCount: 0,

      weekXLabel: [],
      weekseriesArr: [],
      weekcolor: [],
      monthXLabel: [],
      monthseriesArr: [],
      monthcolor: []
    };
  },
  created() {
    this.initTable()
    //获取可视化数据信息
    this.getStatisticalData()

  },
  mounted() {
    // 获取总销售数据
    this.$http
        .get(this.$const.RemoteSensingMall.GoodsCount, "")
        .then((res) => {
          console.log("获取商品销售量:", res);
          if (res.code == 200) {
            this.todayCount = res.data.todayNum;
            this.allCount = res.data.totalNum;
          } else {
            this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          this.$message.error(this.$PubText.InterfaceFail);
        });

    //随着屏幕大小调节图表
    window.addEventListener("resize", this.echartsResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.echartsResize);
  },
  watch: {
    currentbutton: {
      handler(newValue) {
        this.changeoption(newValue)
      }
    }
  },

  methods: {
    //点击需求列表
    clickxulb() {
      this.$router.push({
        name: 'DemandList',
      })
    },


    setbarData(arr, type) {
      let seriesArr = [];//series
      let XLabel = [];//x轴数据
      arr.map((item, index) => {
        let rgb = [
          Math.round(Math.random() * 200 + 55),
          Math.round(Math.random() * 200 + 55),
          Math.round(Math.random() * 200 + 55),
        ].join(',')
        rgb = 'rgb(' + rgb + ')'
        this[type + 'color'].push(rgb)


        XLabel.push(item.value);
        let obj = {};
        obj.name = item.value;
        obj.type = "bar";
        obj.barWidth = 25;
        obj.stack = "广告";
        obj.data = [];
        for (var i = 0; i <= index; i++) {
          if (i != index) {
            obj.data.push(0);
          } else {
            obj.data.push(item.num);
          }
        }
        seriesArr.push(obj);
      });
      this[type + 'XLabel'] = XLabel
      this[type + 'seriesArr'] = seriesArr


      // arr.forEach(item => {
      //   this[type + 'Data'].date.push(item.value)
      //   this[type + 'Data'].count.push(item.num)
      // })

    },
    setpieData(arr, type) {
      arr.forEach(item => {
        let obj = {}
        obj.name = item.value
        obj.value = item.num
        this[type].push(obj)
      })
    },
    //获取可视化信息数据
    async getStatisticalData() {
      try {
        let res = await this.$http.get(this.$const.RemoteSensingMall.getStatisticalData, "")
        if (res.code === 200) {
          let [month, week, satellite, plate] = [res.data.month, res.data.week, res.data.satellite, res.data.plate]
          this.setbarData(month, 'month')
          this.setbarData(week, 'week')
          this.setpieData(satellite, 'pie1_option')
          this.setpieData(plate, 'pie2_option')
          this.barecharts = this.$echarts.init(this.$refs.bar);
          this.pie1echarts = this.$echarts.init(this.$refs.ecPie1);
          this.pie2echarts = this.$echarts.init(this.$refs.ecPie2);
          this.setECBar()
          this.setECPIE1()
          this.setECPIE2()
        }
      } catch (e) {
        console.log(e);
      }
    },

    setECPIE1() {
      var legendData = [];
      this.pie1_option.forEach(item => {
        legendData.push(item.name)
      })
      const option = {
        title: {
          text: '卫星型号',
          left: 20,
          top: '23px',
          textStyle: {
            fontSize: 16
          }
        },

        legend: {
          // 图例
          data: legendData,
          top: 'middle',
          orient: 'vertical',
          right: 'right'
        },

        tooltip: {
          trigger: 'item',
        },

        series: [{
          type: "pie",
          label: {
            normal: {
              show: true,
              position: 'inner',
              // formatter: "{b} {c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
              formatter: "{d}%", // b代表名称，c代表对应值，d代表百分比
              textStyle: {
                color: 'white',
              }
            }
          },
          radius: "60%", //饼图半径
          data: this.pie1_option,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }

        }]
      };
      this.pie1echarts.setOption(option)
    },
    setECPIE2() {
      var legendData = [];
      this.pie2_option.forEach(item => {
        legendData.push(item.name)
      })
      const option = {
        title: {
          text: '应用领域',
          left: 20,
          top: '23px',
          textStyle: {
            fontSize: 16
          }
        },

        legend: {
          // 图例
          data: legendData,
          top: 'middle',
          orient: 'vertical',
          right: "30",
        },

        tooltip: {
          trigger: 'item',
        },

        series: [{
          type: "pie",
          label: {
            normal: {
              show: true,
              position: 'inner',
              // formatter: "{b} {c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
              formatter: "{d}%",
              textStyle: {
                color: 'white',
              }
            }
          },
          radius: "60%", //饼图半径
          data: this.pie2_option,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }

        }]
      };
      this.pie2echarts.setOption(option)
    },
    //初始化柱状图
    setECBar() {


      const option = {
        color: this.monthcolor,
        title: {
          text: '单位：万元',
          left: 20,
          top: '23px',
          textStyle: {
            fontSize: 14
          }
        },
        grid: {
          left: '65px',
          top: '120px'
        },
        legend: {
          data: this.monthXLabel,
          itemWidth: 10,
          itemHeight: 10,
          top: "15%",
          left: "2%"
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          }
        },
        xAxis: {
          type: "category",
          data: this.monthXLabel
        },
        yAxis: {
          axisLine: {
            show: false
          },
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#DDD',
            },
          },
        },
        series: this.monthseriesArr,
      }
      this.barecharts.setOption(option)
    },

    echartsResize() {
      this.barecharts.resize();
      this.pie1echarts.resize()
      this.pie2echarts.resize()
    },

    //初始化表格数据
    initTable() {
      //交易信息
      this.$http.get(this.$const.TradingHall.tradeInfoMSG).then((res) => {
        if (res.code === 200) {
          this.table_trade = res.data;
          var that = this;
          setTimeout(function () {
            that.tableScroll()
          }, 100)
        }
      })
      //需求信息
      this.$http.get(this.$const.TradingHall.demandInfoMSG).then((res) => {
        if (res.code === 200) {
          this.table_commodity_demand = res.data;
        }
      })
      //供应信息
      this.$http.get(this.$const.TradingHall.goodSupplierListMSG).then((res) => {
        if (res.code === 200) {
          this.table_supply = res.data;
        }
      })
      // this.table_trade = tableList.TradingInformation
      // this.table_commodity_demand = tableList.commodity_demand_information
      // this.table_supply = tableList.commodity_supply_information
    },

    //改变echarts数据
    changeoption(newValue) {
      let xlabel
      let series
      let color
      if (newValue === 'month') {
        xlabel = this.monthXLabel
        series = this.monthseriesArr
        color = this.monthcolor

      } else {
        xlabel = this.weekXLabel
        series = this.weekseriesArr
        color = this.weekcolor
      }
      console.log(xlabel, series, color);
      this.barecharts.setOption({
        color: color,
        title: {
          text: '单位：万元',
          left: 20,
          top: '23px',
          textStyle: {
            fontSize: 14
          }
        },
        grid: {
          left: '65px',
          top: '120px'
        },
        legend: {
          data: xlabel,
          itemWidth: 10,
          itemHeight: 10,
          top: "15%",
          left: "2%"
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          }
        },
        xAxis: {
          type: "category",
          data: xlabel
        },
        yAxis: {
          axisLine: {
            show: false
          },
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#DDD',
            },
          },
        },
        series,
      }, true)
    },

    //切换显示模式
    clickBarButton(type) {
      if (type === 'month') { //按月显示
        this.currentbutton = 'month'
      } else { //按周显示
        this.currentbutton = 'week'
      }
    },


    //表格查看详情
    handleClick(row, index) {
      console.log(row, index);
      if(row.goodsCategory==1){
				this.$router.push({ name: "shopDetail", query: { goodsId: row.goodsId}})
			}else{
				this.$router.push({ name: "productDetail", params: { id: row.goodsId}})
			}
      // this.$router.push({
      //   path: "/shopDetail",
      //   query: {
      //     goodsId: row.goodsId
      //   }
      // });
    },

    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return '';
      } else {
        return 'blue';
      }
    },

    //表格自动滚动
    tableScroll() {
      const table = this.$refs.table;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0
        }
      }, 80); // 滚动速度
    }
  },
};
</script>

<style lang="scss" scoped>
.TradingHall {
  background: #F5F5F5;

  .banner {
    width: 100%;
    min-width: 1200px;
    height: 500px;
    padding-top: 30px;
    //background: url('~@/assets/imgs/tradingfloor/tradingfloor_banner.png') no-repeat;
    //background-size: 100% 100%;
    //background-position: center;
    h3 {
      height: 32px;
      font-size: 24px;
      font-family: MicrosoftYaHeiUISemibold;
      color: #2569F2;
      line-height: 32px;
      margin-bottom: 30px;

      span.title {
        padding-left: 8px;
        height: 19px;
        font-size: 16px;
        font-family: Nexa-XBold, Nexa;
        font-weight: normal;
        color: #798AAC;
        line-height: 19px;
      }
    }

    .bannertable {
      height: 84%;
      background: #fff;
      //padding: 10px;
      box-sizing: border-box;
      overflow: hidden;

      div {
        .el-table .blue {
          background: #f5f8fe;
        }

        /deep/ .el-table__header-wrapper {
          border-radius: 5px;
        }

        // 去除滚动的滚动条
        scrollbar-width: none;
        /* firefox */
        -ms-overflow-style: none;

        /* IE 10+ */
        &::-webkit-scrollbar {
          /* Chrome Safari */
          display: none
        }
      }


    }
  }

  .main {
    min-height: 300px;
    margin-top: 15px;
    margin-bottom: 10px;

    .TwoTableBox {
      //display: flex;
      //justify-content: space-between;
      width: 100%;
      margin-bottom: 25px;

      .leftTable {
        h3 {
          height: 32px;
          font-size: 24px;
          font-family: MicrosoftYaHeiUISemibold;
          color: #2569F2;
          line-height: 32px;
          margin-bottom: 30px;
          margin-top: 30px;

          span.title {
            padding-left: 8px;
            height: 19px;
            font-size: 16px;
            font-family: Nexa-XBold, Nexa;
            font-weight: normal;
            color: #798AAC;
            line-height: 19px;
          }
        }

        .supply {
          background: url("./xqxx.png") no-repeat;
          background-color: white;
          padding-top: 50px;
          position: relative;

          /deep/ .el-table__header-wrapper {
            border-radius: 5px;
          }

          div.xqxx {
            position: absolute;
            top: 14px;
            left: 15px;
            font-size: 18px;
            font-family: MicrosoftYaHeiUI;
            color: #FFFFFF;
          }

          .xqxxbox {
            padding: 10px 20px;
          }
        }

        .demand {
          background: url("./gyxx.png") no-repeat;
          background-color: white;
          padding-top: 50px;
          position: relative;

          /deep/ .el-table__header-wrapper {
            border-radius: 5px;
          }

          div.gyxx {
            position: absolute;
            top: 14px;
            left: 15px;
            font-size: 18px;
            font-family: MicrosoftYaHeiUI;
            color: #FFFFFF;
          }

          .gyxxbox {
            padding: 10px 20px;
          }
        }
      }

      .leftTable {
        span.xulb {
          float: right;
          font-size: 14px;
          padding-right: 20px;
          font-weight: normal;

          &:hover {
            cursor: pointer;
            color: blue;
          }
        }
      }
    }


    .echartsBox1 {
      display: flex;
      justify-content: space-between;

      .left {
        width: 77%;
        margin-right: 20px;
        height: 750px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .barBox {
          background: white;
          padding-top: 20px;
          //background: red;
          margin-bottom: 10px;
          height: 55%;

          .barButton {
            display: flex;
            padding-left: 20px;

            div {
              width: 200px;
              height: 50px;
              background: #ECEFF5;
              border-radius: 8px;

              font-size: 20px;
              font-family: MicrosoftYaHeiUISemibold;
              color: #2569F2;

              text-align: center;
              line-height: 50px;
              cursor: pointer;
              border: 1px solid #dde4ea;
            }

            div.currentClass {
              font-family: MicrosoftYaHeiUISemibold;
              color: #FFFFFF;
              background: #2569F2;
            }
          }

          .bar {
            width: 100%;
            height: 100%;
          }
        }

        .pieBox {
          width: 100%;
          height: 49%;
          background: #fafafa;
          margin-bottom: 10px;
          display: flex;

          .pie1 {
            width: 50%;
            height: 100%;
            background: white;
            //background: yellow;
          }

          .pie2 {
            width: 50%;
            height: 100%;
            background: white;
            margin-left: 10px;
            //background: red;
          }
        }
      }

      .right {
        height: 740px;
        background: white;
        padding: 20px;
        box-sizing: border-box;

        .dataShow_rankTitle {
          font-size: 18px;
          margin-bottom: 10px;
          font-weight: 600;
        }

        .dataShow_dataItemInfo {
          font-size: 14px;
          width: 100%;
          height: 28px;
          line-height: 14px;
          margin-bottom: 10px;
        }

        .dataShow_dataItemInfoMoney {
          font-weight: bold;
          color: #e24087;
        }

        .dataShow_dataItemInfoBox {
          padding: 10px;
          height: 60px;
        }

        .dataShow_dataItemImgBox {
          width: 100%;
          height: 210px;
        }

        .dataShow_dataItem {
          width: 30%;
          height: 290px;
          margin-bottom: 10px;
          background: #fff;
          border: 1px solid #ccc;
        }

        /* 如果最后一行是2个元素 */
        .dataShow_dataItem:last-child:nth-child(3n - 1) {
          margin-right: calc(30% + 10% / 2);
        }

        .dataShow_dataItem:hover {
          box-shadow: 0px 0px 5px #8fbbee;
          border: 1px solid #8fbbee;
        }

        .dataShow_rank {
          width: 25%;
          padding: 20px;
          background: #f5f7fa;
        }

        .dataShow_data {
          width: 70%;
          padding: 20px 0;
          margin-right: 20px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          background: #f5f7fa;
        }

        .dataShowBox {
          display: flex;
          margin-bottom: 5px;
        }


      }
    }
  }
}
</style>
